import { z } from 'zod';

export const MeetingNoteFormSchema = z
  .object({
    id: z.string(),
    meetingId: z.string(),
    internalNote: z.string().optional(),
  })
  .superRefine((data, ctx: any) => {
    if (!data.meetingId?.trim()) {
      ctx.addIssue({
        path: ['meetingId'],
        message: 'This field is required',
        code: 'custom',
      });
    }
  });
